module.exports = __webpack_public_path__ + "media/honey-icons/icon-view-cb837fc9.svg";